
export const TARIFAS_OFERTA = {
    electrico: [
        { id: 41, name: "2.0TD", key: "20" },
        { id: 42, name: "3.0TD", key: "30" },
        { id: 43, name: "6.1TD", key: "6" },
    ],
    gas: [
        { id: 11, name: "RL01", key: "RL01" },
        { id: 12, name: "RL02", key: "RL02" },
        { id: 13, name: "RL03", key: "RL03" },
        { id: 14, name: "RL04", key: "RL04" },
        { id: 22, name: "RLTB5", key: "RLTB5" },
    ]
};

export const TYPE_OFERTA_OPTIONS = [
    { value: "simple", label: "Contrato Nuevo" },
    { value: "renovacion", label: "Renovación" }
];

export const MODE_FACTURACIO_OPTIONS = [
    { value: "index", label: "Indexada" },
    { value: "atr", label: "Fijo" }
];

// Tabla de códigos ATR (codigoTarifaATREnVigor) a nombre de tarifa de acceso
export const CODIGOS_TARIFA_ATR = {
    "001": "2.0A",
    "003": "3.0A",
    "004": "2.0DHA",
    "005": "2.1A",
    "006": "2.1DHA",
    "007": "2.0DHS",
    "008": "2.1DHS",
    "011": "3.1A",
    "012": "6.1A",
    "013": "6.2",
    "014": "6.3",
    "015": "6.4",
    "016": "6.5",
    "017": "6.1B",
    "018": "2.0TD",
    "019": "3.0TD",
    "020": "6.1TD",
    "021": "6.2TD",
    "022": "6.3TD",
    "023": "6.4TD",
    "024": "3.0TDVE",
    "025": "6.1TDVE",
};

export const defaultValues = {
    type_oferta: "",
    sub_type_offer: "",
    tarifa_comercial: "",
    tarifa_oferta: "",
    mode_facturacio: "",
    coeficient_k: 10,
    coeficient_d: 7,
    numero_ctto: "",
    fecha_estimada_inicio_ctto: "",
    showDatePicker: null,
};